const styles = {
  container: {
    position: 'absolute',
    top: '5vh',
    paddingLeft: '3em',
    height: '85vh',
    paddingBottom: '2em',
    overflowX: 'auto',
    width: '100%',
  },
  separation: {
    display: 'block',
    marginTop: '1em',
    marginBottom: '1em',
  },
};

export default styles;
